/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerControllerDtoRemoveTwoFactorRequest model module.
 * @module model/ManagerControllerDtoRemoveTwoFactorRequest
 * @version 1.0
 */
class ManagerControllerDtoRemoveTwoFactorRequest {
    /**
     * Constructs a new <code>ManagerControllerDtoRemoveTwoFactorRequest</code>.
     * @alias module:model/ManagerControllerDtoRemoveTwoFactorRequest
     * @param managerNo {Number} 
     */
    constructor(managerNo) { 
        
        ManagerControllerDtoRemoveTwoFactorRequest.initialize(this, managerNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, managerNo) { 
        obj['managerNo'] = managerNo;
    }

    /**
     * Constructs a <code>ManagerControllerDtoRemoveTwoFactorRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerControllerDtoRemoveTwoFactorRequest} obj Optional instance to populate.
     * @return {module:model/ManagerControllerDtoRemoveTwoFactorRequest} The populated <code>ManagerControllerDtoRemoveTwoFactorRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerControllerDtoRemoveTwoFactorRequest();

            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerControllerDtoRemoveTwoFactorRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerControllerDtoRemoveTwoFactorRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerControllerDtoRemoveTwoFactorRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

ManagerControllerDtoRemoveTwoFactorRequest.RequiredProperties = ["managerNo"];

/**
 * @member {Number} managerNo
 */
ManagerControllerDtoRemoveTwoFactorRequest.prototype['managerNo'] = undefined;






export default ManagerControllerDtoRemoveTwoFactorRequest;

